import Vue from "vue";

// Components
// These components can be accessed anywhere without having to import them
import RiaSelect from "@/components/form/elements/ria-select.vue";
Vue.component("ria-select", RiaSelect);

import LocaleSelect from "@/components/common/locale-select.vue";
Vue.component("locale-select", LocaleSelect);

import RiaDatepicker from "@/components/form/elements/ria-datepicker.vue";
Vue.component("ria-datepicker", RiaDatepicker);
